import { ERROR_MENTION_NEEDED, missionPhotoField } from '../../../../utils/constants'

export default (page, { answer = {} }) => {
  const has_answer = answer[missionPhotoField(page)]
  return {
    valid: !!has_answer,
    is_correct_answer: true,
    errors: has_answer ? new Set() : new Set([
      ERROR_MENTION_NEEDED,
    ]),
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/recognition.jsx